<template>
  <div class="hostess-income-rank-base" :style="cssVars()">
    <div class="hostess-income-rank-bg">
      <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
        <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
          <template #left>
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          </template>
          <template #right>
            <img class="right-nav" src="@/assets/packageAssets/common/rules01.png" alt="" />
          </template>
        </van-nav-bar>
      </div>

      <div class="switch-tab">
        <div class="tab-item" :class="{ 'tab-on': dateType === 'day' }" @click="handleDate('day')">{{ $t('lang.HostessIncomeRank.k001') }}</div>
        <div class="tab-item" :class="{ 'tab-on': dateType === 'week' }" @click="handleDate('week')">{{ $t('lang.HostessIncomeRank.k002') }}</div>
      </div>

      <div class="select-tab">
        <div class="tab-item" :class="{ 'tab-on': costType === 'income' }" @click="handleCost('income')">{{ $t('lang.BaseCommon.k032') }}</div>
        <div class="tab-item" :class="{ 'tab-on': costType === 'gift' }" @click="handleCost('gift')">{{ $t('lang.BaseCommon.k075') }}</div>
      </div>

      <div class="hostess-income-rank-bar">
        <div class="prize">
          <div class="two">
            <div class="rank_c2_avatar">
              <img v-if="prize2.avatar" :src="prize2.avatar | imgPath" alt="" />
            </div>
            <div class="rank-sort"></div>
            <div class="item-num">
              <span class="name">{{ prize2.nickname }}</span>
              <span class="num">
                {{ prize2.score }}
                <img v-show="prize2.score" :src="getMatchImg('beans')" />
              </span>
            </div>
          </div>

          <div class="one">
            <div class="rank_c1_avatar">
              <img v-if="prize1.avatar" :src="prize1.avatar | imgPath" alt="" />
            </div>
            <div class="rank-sort"></div>
            <div class="item-num">
              <span class="name">{{ prize1.nickname }}</span>
              <span class="num">
                {{ prize1.score }}
                <img v-show="prize1.score" :src="getMatchImg('beans')" />
              </span>
            </div>
          </div>

          <div class="three">
            <div class="rank_c3_avatar">
              <img v-if="prize3.avatar" :src="prize3.avatar | imgPath" alt="" />
            </div>
            <div class="rank-sort"></div>
            <div class="item-num">
              <span class="name">{{ prize3.nickname }}</span>
              <span class="num">
                {{ prize3.score }}
                <img v-show="prize3.score" :src="getMatchImg('beans')" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="hostess-income-rank-con">
        <div class="rank-body">
          <div class="date-limit">
            <div class="timename">{{ $t('lang.BaseCommon.k070') }}</div>
            <span class="time">{{ startTime }} ~ {{ endTime }}</span>
          </div>
          <template v-if="rankList && rankList.length > 0">
            <div class="agent-item" v-for="item in rankList" :key="item">
              <span class="rank-num" v-if="item.rank">{{ item.rank }}</span>
              <div class="avatar rank-avatar">
                <img v-if="item.avatar" :src="item.avatar | imgPath" alt="" />
                <span>{{ item.nickname }}</span>
              </div>
              <div class="item-num">
                {{ item.score }}
                <img :src="getMatchImg('beans')" />
              </div>
            </div>
          </template>
          <div class="rank-nodata" v-else>
            {{ $t('lang.BaseCommon.k020') }}
          </div>
        </div>

        <div class="owner-item">
          <div class="owner-item-content">
            <div class="avatar">
              <span v-if="owners.rank && owners.rank > 0" class="rank-num">{{ owners.rank }}</span>
              <span v-else class="rank-num">--</span>
              <div class="avatar-box">
                <img v-if="owners.avatar" :src="owners.avatar | imgPath" alt="" />
                <div>
                  <span class="owner-nickname">{{ owners.nickname }}</span>
                  <span v-if="!owners.rank || !(owners.rank > 0)" class="owner-rank">{{ $t('lang.BaseCommon.k020') }}</span>
                </div>
              </div>
            </div>
            <div class="item-num">
              {{ owners.score || 0 }}
              <img :src="getMatchImg('beans')" />
            </div>
          </div>
          <div style="width: 100%" :style="{ height: `${bottomBarHeight}px` }"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Girls/HostessIncomeRank/z-style-cfg.js'

import { hostessIncomeRank } from '@/api/imee.js'

export default {
  mixins: [pageCssVars],
  data() {
    return {
      rankList: [],
      owners: {},
      showRules: false,
      prize1: { nickname: '', avatar: '', score: '', rank: '' },
      prize2: { nickname: '', avatar: '', score: '', rank: '' },
      prize3: { nickname: '', avatar: '', score: '', rank: '' },
      // 榜类型
      dateType: 'day',
      costType: 'income',
      startTime: '',
      endTime: '',
    }
  },
  methods: {
    // 规则
    handleToRule() {
      this.$router.push({ path: '/hostess-income-rank-rules', query: { start: this.startTime } })
    },
    // 获取数据
    fatchRanking() {
      hostessIncomeRank(this.costType, this.dateType).then((resData) => {
        if (resData) {
          // 排名数据
          if (resData.ranks && resData.ranks.length > 0) {
            // 前三名
            this.prize1 = resData.ranks[0] || { nickname: '', avatar: '', score: '', rank: '' }
            this.prize2 = resData.ranks[1] || { nickname: '', avatar: '', score: '', rank: '' }
            this.prize3 = resData.ranks[2] || { nickname: '', avatar: '', score: '', rank: '' }

            // 已排名
            if (this.prize1.rank) {
              this.rankList = resData.ranks && resData.ranks.slice(3)
            }
            // 未排名
            else {
              this.rankList = resData.ranks
            }
          }
          // 没数据
          else {
            this.prize1 = { nickname: '', avatar: '', score: '', rank: '' }
            this.prize2 = { nickname: '', avatar: '', score: '', rank: '' }
            this.prize3 = { nickname: '', avatar: '', score: '', rank: '' }
            this.rankList = []
          }

          // 用户数据
          if (resData.owners) {
            this.owners = resData.owners
          }
          // 没数据
          else {
            this.owners = {}
          }

          this.startTime = resData.rankStartTime || ''
          this.endTime = resData.rankEndTime || ''
        }
      })
    },
    // 模拟数据
    mockRanking() {
      const resData = {
        owners: {
          avatar: 'public/picture/2023-07-07/acf4942604ecae168398d19c38d92423.jpg',
          gifts: 0,
          nickname: 'Greenwalt',
          points: 0,
          presentId: '1079',
          uid: 1079,
          score: 123,
          rank: 4,
        },
        ranks: [
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            score: 4,
            rank: 1,
          },
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            score: 3,
            rank: 2,
          },
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            score: 2,
            rank: 3,
          },
          {
            avatar: 'public/app/picture/250322/17426128036575b21aa9a33da44c5R5828.jpg',
            gifts: 14,
            nickname: '453ysh',
            presentId: '7560252',
            uid: 4002,
            score: 123,
            rank: 4,
          },
        ],
      }
      if (resData) {
        // 排名数据
        if (resData.ranks && resData.ranks.length > 0) {
          resData.ranks = resData.ranks.concat(resData.ranks[1]).concat(resData.ranks[1])
          // 前三名
          this.prize1 = resData.ranks[0] || { nickname: '', avatar: '', score: '', rank: '' }
          this.prize2 = resData.ranks[1] || { nickname: '', avatar: '', score: '', rank: '' }
          this.prize3 = resData.ranks[2] || { nickname: '', avatar: '', score: '', rank: '' }
          // 已排名
          if (this.prize1.rank) {
            this.rankList = resData.ranks && resData.ranks.slice(3)
          }
          // 未排名
          else {
            this.rankList = resData.ranks
          }
        }
        // 没数据
        else {
          this.prize1 = { nickname: '', avatar: '', score: '', rank: '' }
          this.prize2 = { nickname: '', avatar: '', score: '', rank: '' }
          this.prize3 = { nickname: '', avatar: '', score: '', rank: '' }
          this.rankList = []
        }
        // 用户数据
        if (resData.owners) {
          this.owners = resData.owners
        }
        // 没数据
        else {
          this.owners = {}
        }
      }
    },
    handleDate(arg) {
      this.dateType = arg
      this.fatchRanking()
    },
    handleCost(arg) {
      this.costType = arg
      this.fatchRanking()
    },
  },
  created() {
    this.fatchRanking()
    // this.mockRanking()
  },
}
</script>

<style lang="less">
.hostess-income-rank-base {
  width: 100%;
  min-height: calc(100vh - 150px);
}
</style>

<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}

.hostess-income-rank-base {
  background: linear-gradient(0deg, var(--page-color01, fffbf5) 0%, var(--page-color02, #fffaf0) 50%, var(--page-color03, #ffe5ad) 100%);

  .hostess-income-rank-bg {
    background: var(--icon-bg-1) top left / 100% auto no-repeat;

    .custom-nav-block {
      background: var(--page-color04, #ffe5ad) var(--icon-bg-1) top left / 100% auto no-repeat;
    }

    .switch-tab {
      width: 100%;
      margin-top: 22px;
      display: flex;
      .tab-item {
        flex: 1;
        height: 44px;
        color: var(--page-color05, #5f656a);
        font-family: var(--page-font01, 'Roboto-Regular');
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        position: relative;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 2px;
          border-radius: 4px 4px 0 0;
        }

        &.tab-on {
          color: var(--page-color06, #202326);
          &::after {
            background: var(--page-color07, #0c0e11);
          }
        }
      }
    }

    .select-tab {
      width: 230px;
      height: 36px;
      margin: 16px auto 0;
      border-radius: var(--page-radius01, 30px);
      background: var(--page-color08, rgba(255, 255, 255, 0.8));
      display: flex;
      .tab-item {
        flex: 1;
        height: 36px;
        border-radius: var(--page-radius01, 30px);
        color: var(--page-color09, #8e9092);
        background: var(--page-color10, rgba(255, 255, 255, 0.8));

        font-family: var(--page-font02, 'Roboto-Regular');
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;

        display: flex;
        align-items: center;
        justify-content: center;

        &.tab-on {
          color: var(--page-color11, #202326);
          background: var(--page-color12, #ffb94d);
        }
      }
    }

    .hostess-income-rank-bar {
      padding-top: 16px;
      position: relative;

      .prize {
        width: 100%;
        margin: 10px auto;
        display: flex;
        justify-content: center;
        .one,
        .two,
        .three {
          width: 125px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .item-num {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .name {
              width: 100%;
              color: var(--page-color13, #202326);
              padding: 0 6px;
              text-align: center;
              font-family: var(--page-font03, 'Roboto-Regular');
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .num {
              color: var(--page-color14, #ffa433);
              font-family: var(--page-font04, 'Roboto-Regular');
              font-size: 20px;
              font-weight: 500;
              line-height: 28px;

              display: flex;
              align-items: center;
              img {
                width: 20px;
              }
            }
          }
        }
        .two,
        .three {
          padding-top: 26px;
        }
        .one {
          .rank_c1_avatar {
            width: 90px;
            height: 90px;
            border-radius: 50%;
            border: 3px solid var(--page-color15, #ffd00b);
            position: relative;
            img {
              object-fit: cover;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .rank-sort {
            width: 40px;
            height: 40px;
            margin-top: -22px;
            position: relative;
            background: var(--icon-h-first) top left / 100% auto no-repeat;
          }
        }
        .two {
          .rank_c2_avatar {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            border: 3px solid #dbdddf;
            position: relative;
            img {
              object-fit: cover;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .rank-sort {
            width: 40px;
            height: 40px;
            margin-top: -22px;
            position: relative;
            background: var(--icon-h-second) top left / 100% auto no-repeat;
          }
        }
        .three {
          .rank_c3_avatar {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            border: 3px solid var(--page-color16, #f59d4d);
            position: relative;
            img {
              object-fit: cover;
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .rank-sort {
            width: 40px;
            height: 40px;
            margin-top: -22px;
            position: relative;
            background: var(--icon-h-third) top left / 100% auto no-repeat;
          }
        }
      }
    }

    .hostess-income-rank-con {
      width: 100%;
      min-height: 100vh;
      border-radius: 16px 16px 0 0;
      background: var(--page-color17, #ffffff);
      position: relative;

      .rank-body {
        padding: 16px;
        padding-bottom: 90px;
        border-radius: 0px 0px 16px 16px;
        position: relative;
        .date-limit {
          font-family: var(--page-font05, 'Outfit-Regular');
          font-size: 14px;
          line-height: 18px;
          color: var(--page-color18, #222222);
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 16px;
          .timename {
            color: var(--page-color19, #8e9092);
            font-family: var(--page-font06, 'Roboto-Regular');
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
          }
          .time {
            float: right;
            color: var(--page-color20, #8e9092);
            font-family: var(--page-font07, 'Outfit-Regular');
            font-size: 14px;
          }
        }
        .rank-nodata {
          width: 100%;
          text-align: center;
          padding-top: 90px;
          font-size: 14px;
          color: var(--page-color21, #999999);
          font-family: var(--page-font08, 'Outfit-Medium');
        }
      }
      .agent-item {
        height: 40px;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: var(--page-font09, 'Inter-Regular');
        &:last-child {
          margin-bottom: 0;
        }
        .rank-num {
          display: block;
          min-width: 18px;
          margin-right: 10px;
          color: var(--page-color22, #8e9092);
          font-family: var(--page-font10, 'Roboto-Regular');
          font-size: 20px;
          font-weight: 500;
          line-height: 28px;
        }
        .avatar {
          display: flex;
          align-items: center;

          color: var(--page-color23, #202326);
          text-align: center;
          font-family: var(--page-font11, 'Roboto-Regular');
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          > img {
            flex: 0 0 auto;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
            object-fit: cover;
          }
          > span {
            max-width: 150px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            word-break: break-all;
          }
        }
        .rank-avatar {
          flex: 1;
        }
        .item-num {
          display: flex;
          align-items: center;

          color: var(--page-color24, #ffa433);
          font-family: var(--page-font12, 'Roboto-Regular');
          font-size: 20px;
          font-weight: 500;
          line-height: 28px;

          > img {
            width: 20px;
          }
        }
      }

      .owner-item {
        width: 100%;
        height: auto;
        position: fixed;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        border-radius: 16px 16px 0 0;
        background: var(--page-color25, #fff4d6);
        display: flex;
        flex-direction: column;

        .owner-item-content {
          width: 100%;
          margin: 0 auto;
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .avatar {
            display: flex;
            justify-content: space-between;
            font-size: 14px;

            .rank-num {
              display: block;
              min-width: 18px;
              margin-right: 10px;
              color: var(--page-color26, #8e9092);
              font-family: var(--page-font13, 'Roboto-Regular');
              font-size: 20px;
              font-weight: 500;
              display: flex;
              align-items: center;
            }
            .avatar-box {
              display: flex;
              align-items: center;

              > img {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                object-fit: cover;
              }

              > div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding-left: 12px;
                max-width: 180px;
                overflow: hidden;

                .owner-nickname {
                  color: var(--page-color27, #202326);
                  font-family: var(--page-font14, 'Roboto-Regular');
                  font-size: 16px;
                  font-weight: 500;
                  line-height: 24px;
                }

                .owner-rank {
                  color: var(--page-color28, #8e9092);
                  font-family: var(--page-font15, 'Roboto-Regular');
                  font-size: 12px;
                  font-weight: 500;
                  line-height: 18px;
                }
              }
            }
          }

          .item-num {
            display: flex;
            align-items: center;

            color: var(--page-color29, #ffa433);
            font-family: var(--page-font16, 'Roboto-Regular');
            font-size: 20px;
            font-weight: 500;
            line-height: 28px;

            > img {
              width: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
